import { Link } from "react-router-dom";

export const SMS_MARKETING_CONSENT_TEXT =
  "By checking this box, I agree to receive recurring automated promotional and marketing text messages from ResidenceProof " +
  "at the mobile number provided. Message frequency varies. Message and data rates may apply. Reply STOP to opt out at any time " +
  "or HELP for help. Consent is not a condition of any purchase.";

export const TWOFA_CONSENT_TEXT =
  "By checking this box, I agree to receive one-time verification codes (two-factor authentication) by text message from " +
  "ResidenceProof at the mobile number provided, each time I sign in or confirm a sensitive action. Message frequency varies " +
  "based on account activity. Message and data rates may apply. Reply STOP to opt out or HELP for help.";

const TERMS = (support) => [
  ["Program", "ResidenceProof Communications: promotional offers, mixed marketing campaigns, account updates and, if you opt in separately, two-factor verification codes."],
  ["Frequency", "Message frequency varies. Marketing messages are occasional; account and verification messages are sent as events occur."],
  ["Cost", "Message and data rates may apply, according to your mobile plan."],
  ["Opt out", "Reply STOP to any message to cancel. You'll receive one confirmation and no further texts from that program."],
  ["Help", `Reply HELP for help, or email ${support}.`],
  ["Privacy", "No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Text-messaging opt-in data and consent are never sold or shared."],
  ["Carriers", "Carriers are not liable for delayed or undelivered messages."],
];

export const SmsTermsBlock = ({ support, testid = "sms-terms-block" }) => (
  <div className="rounded-2xl border border-gray-200 bg-oath-bg/60 p-4" data-testid={testid}>
    <div className="font-mono-label text-[10px] font-semibold text-oath-ink">SMS TERMS &amp; CONDITIONS</div>
    <dl className="mt-3 grid gap-2 text-xs leading-relaxed">
      {TERMS(support).map(([k, v]) => (
        <div key={k} className="grid gap-0.5 sm:grid-cols-[90px_1fr] sm:gap-3">
          <dt className="font-semibold text-oath-ink">{k}</dt>
          <dd className="text-oath-secondary">{v}</dd>
        </div>
      ))}
    </dl>
    <p className="mt-3 text-xs text-oath-muted">
      Full details: <Link to="/messaging-terms" className="text-oath-accent underline" data-testid={`${testid}-messaging-link`}>Messaging Terms</Link>{" "}
      and <Link to="/privacy" className="text-oath-accent underline" data-testid={`${testid}-privacy-link`}>Privacy Policy</Link>.
    </p>
  </div>
);
